module.exports = __webpack_public_path__ + "static/img/toLeft-icon.2d2793d3.svg";